// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.library-dashboard-view .card {
  height: 140px !important;
}
.library-dashboard-view .card .dropdown-content {
  padding: 0px !important;
}
.library-dashboard-view .card .dropdown-content .dropdown-item:hover {
  background-color: #e7e7e7 !important;
}
.library-dashboard-view .card .dropdown-content .dropdown-divider {
  margin: 0px !important;
}

.modal .modal-card {
  width: calc(100% - 20px) !important;
}

.survey-modal .card-content, .poll-modal .card-content {
  padding: 1rem 1.5rem !important;
}
.survey-modal .survey-question:first-child h3, .survey-modal .poll-question:first-child h3, .poll-modal .survey-question:first-child h3, .poll-modal .poll-question:first-child h3 {
  margin-top: 0px !important;
  font-size: 1.1rem !important;
}
.survey-modal .is-medium, .poll-modal .is-medium {
  font-size: 1rem !important;
}

.assQuestTest .label {
  color: #353535 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/elibraryandcourse/e-library/e-library-details/e-library-dashboard/e-library-dashboard.component.scss"],"names":[],"mappings":"AACE;EACI,wBAAA;AAAN;AACM;EACE,uBAAA;AACR;AAAQ;EACE,oCAAA;AAEV;AAAQ;EACE,sBAAA;AAEV;;AAOI;EACE,mCAAA;AAJN;;AASI;EACE,+BAAA;AANN;AASM;EACE,0BAAA;EACA,4BAAA;AAPR;AAUI;EACE,0BAAA;AARN;;AAYI;EACE,yBAAA;AATN","sourcesContent":[".library-dashboard-view{\n  .card{\n      height:140px !important;\n      .dropdown-content{\n        padding:0px !important;\n        .dropdown-item:hover{\n          background-color:#e7e7e7 !important;\n        }\n        .dropdown-divider{\n          margin:0px !important;\n        }\n      }\n    }\n\n}\n\n.modal{\n  \n    .modal-card{\n      width:calc(100% - 20px) !important;\n    }\n}\n\n  .survey-modal,.poll-modal{\n    .card-content{\n      padding:1rem 1.5rem !important;\n    }\n    .survey-question:first-child,.poll-question:first-child{\n      h3{\n        margin-top:0px !important;\n        font-size:1.1rem !important;\n      }\n    }\n    .is-medium{\n      font-size: 1rem !important;\n    }\n  } \n  .assQuestTest{\n    .label{\n      color:#353535 !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
